<template>
    <div class="left-side" v-if="profile.corporateProfile.affiliation && profile.corporateProfile.affiliation.length">
        <div class="page-header">
			<h1 class="m-n text-u-c title-font">Affiliations</h1>
		</div>
        <div class="row">
            <div class="col-lg-12 p-x-n" v-for="affiliation in profile.corporateProfile.affiliation">
                <span class="block m-b-md">
                    <span class="block style-font">{{ affiliation.organization }}</span>
                    <small v-if="affiliation.start_date || affiliation.end_date" class="text-font text-uppercase">
                      <span v-if="affiliation.start_date">{{ moment(affiliation.start_date).format('MMM YYYY')}}</span><span v-else>Current</span> -
                      <span v-if="affiliation.end_date">{{ moment(affiliation.end_date).format('MMM YYYY')}}</span><span v-else>Current</span>
                    </small>
                </span>
            </div>
        </div>
    </div>
</template>



<script>
import { mapGetters }   from 'vuex'
import moment from 'moment'

export default {
  data(){
    return {
      moment: moment
    }
  },
  computed : {
    ...mapGetters([
      'profile',
    ])
  },
}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 1200px) { 
	.left-side .page-header {
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 20px;
		line-height: 20px;
		color: #000;
	}
	.text-font {
		font-weight: normal;
		font-size: 13px;
		line-height: 15px;
		color: #888888;
	}
	.style-font {
		font-weight: normal;
		font-size: 14px;
		line-height: 14px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}
@media only screen and (max-width: 1199px) and (min-width: 768px) {
	.left-side .page-header {
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 20px;
		line-height: 20px;
		color: #000;
	}
	.text-font {
		font-weight: normal;
		font-size: 11px;
		line-height: 13px;
		color: #888888;
	}
	.style-font {
		font-weight: normal;
		font-size: 12px;
		line-height: 14px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}
@media only screen and (max-width: 767px) { 
	.left-side {
		padding-left: 20px;
	}
	.left-side .page-header {
		padding-bottom: 20px;
	}
	.title-font {
		font-weight: 300;
		font-size: 20px;
		line-height: 20px;
		color: #000;
	}
	.text-font {
		font-weight: normal;
		font-size: 13px;
		line-height: 15px;
		color: #888888;
	}
	.style-font {
		font-weight: normal;
		font-size: 14px;
		line-height: 14px;
		color: #000;
	}	
	.page-header {
		margin: 0px;
	}
	.row {
		margin: 0px;
	}
}
</style>
